<template>
  <div style="display: contents;">
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navBar"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon" />
    </button>
    <div
      id="navBar"
      class="collapse navbar-collapse"
    >
      <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <router-link
            class="nav-link"
            :to="{ name: 'about'}"
          >
            About
          </router-link>
        </li>

        <li class="nav-item dropdown">
          <a
            id="spiralsDropdown"
            class="nav-link dropdown-toggle"
            href="#"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            SPIRALs
          </a>
          <div
            class="dropdown-menu"
            aria-labelledby="spiralsDropdown"
          >
            <router-link
              class="dropdown-item"
              :to="{ name: 'food-spirals' }"
            >
              FOOD SPIRALs&reg;
            </router-link>
            <router-link
              class="dropdown-item"
              :to="{ name: 'fitness-spirals' }"
            >
              Fitness SPIRALs&reg;
            </router-link>
          </div>
        </li>

        <li class="nav-item">
          <router-link
            class="nav-link caret-after"
            :to="{ name: 'faq'}"
          >
            FAQ
          </router-link>
        </li>

        <li class="nav-item">
          <router-link
            class="nav-link"
            :to="{ name: 'blog'}"
          >
            Blog
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :to="{ name: 'recipes'}"
          >
            Recipes
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :to="{name: 'events'}"
          >
            Events
          </router-link>
        </li>
        <li class="nav-item">
          <a href="https://store.foodfitnessfirst.com/">
            <div class="nav-link">Store</div>
          </a>
        </li>
        <li class="nav-item dropdown">
          <a
            id="accountDropdown"
            class="nav-link dropdown-toggle"
            href="#"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            My FFF
          </a>
          <MenuAccountLinks
            class="dropdown-menu"
            aria-labelledby="accountDropdown"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import MenuAccountLinks from "./MenuAccountLinks.vue";

export default {
  components: {MenuAccountLinks}
}
</script>

<style lang="scss" scoped>
    a {
        text-decoration: none;
    }

    a.caret-before {
        padding-right:1px !important;
    }

    .caret-menu {
        top: 8px;
        position: absolute;
        margin-left: 14px;
    }

    @media only screen and (min-width: 992px){
        .caret-menu {
            margin-left: -3px;
        }
    }

    @media only screen and (min-width: 1200px){
        .caret-menu {
            margin-left: -8px;
        }
    }

    .pull-left {
        float: left;
    }

</style>
